import './js/aos';
import { bodyUtils, buttonUtils, navUtils, rellaxUtils, windowScrollUtils } from './js/body';
import './js/sliders';
import { sliderUtils } from './js/sliders';

document.addEventListener('DOMContentLoaded', function() {
  bodyUtils();
  navUtils();
  sliderUtils();
  buttonUtils();
  rellaxUtils();
});

window.addEventListener('load', function() {
  windowScrollUtils();
});

window.addEventListener('resize', function() {
  // Add any resize specific code here
});

window.addEventListener('scroll', function() {
  windowScrollUtils();
});

import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupDebugPlugin from '@swup/debug-plugin';
import SwupParallelPlugin from '@swup/parallel-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';

const swup = new Swup({
  animateHistoryBrowsing: true,
  containers: [ '#swup' ],
  linkToSelf: 'scroll',
  ignoreVisit: (url, { el } = {}) => el?.closest('[rel=\'no-swup\']'),
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupHeadPlugin({
      awaitAssets: true,
      persistTags: true,
    }),
    new SwupPreloadPlugin(),
    new SwupGaPlugin({ gaMeasurementId: 'G-0BBGXC72D1' }),
    new SwupDebugPlugin(),
    new SwupParallelPlugin({ keep: 1 }),
    new SwupScrollPlugin({
      animateScroll: {
        betweenPages: false,
        samePageWithHash: true,
        samePage: false,
      },
    }),
  ],
});

swup.hooks.on('page:view', () => {
  navUtils();
  sliderUtils();
  rellaxUtils();
  buttonUtils();
  bodyUtils();
  windowScrollUtils();

  // ACF Blocks
  window.lightbox.init();
});

swup.hooks.on('content:remove', () => {
  $('.transition-slide.is-kept-container').css('display', 'none');
});
